import { Component } from '@angular/core';

@Component({
  selector: 'app-sms-icon',
  templateUrl: './sms-icon.component.html'
})
export class SmsIconComponent {

}
